import { Component, Input, Output, OnInit, ViewChild, EventEmitter, AfterViewChecked, SimpleChanges } from '@angular/core';
import { AuthDataStorageService } from '../../auth/services/auth-data-storage.service';
import {config} from '../../app.config';

declare var jQuery: any;

@Component({
  selector: 'ch-offer-preview-modal-dialog',
  templateUrl: './offer-preview-modal-dialog.component.html',
  styleUrls: ['./offer-preview-modal-dialog.component.css'],
})
export class OfferPreviewModalDialogComponent implements OnInit {
  @Input() public show: boolean;
  @Input() public data: any;
  @Output() public onClose: EventEmitter<any> = new EventEmitter();
  @ViewChild('modal') private modal;
  private change: boolean;
  public authToken: string;

  constructor(
    private authDataStorageService: AuthDataStorageService
    ) {
      this.authToken = this.authDataStorageService.getSessionTokenFromStorage();
    }

  ngOnInit() { }

  ngOnChanges() {
    if (this.show) {
      this.change = true;
    }
  }

  ngAfterViewChecked() {
    if (this.change) {
      jQuery(this.modal.nativeElement)
        .modal({
          backdrop: false
        })
        .on('hidden.bs.modal', e => {
          this.onClose.emit(e);
        });

      this.change = false;
    }
  }

  public closeDialog() {
    jQuery(this.modal.nativeElement).modal('hide');
  }

  get imageUrl() {
    return config.api_url + 'resources/' + this.data.imageId + '?x-auth-token=' + this.authToken;
  }
}



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/core/offer-preview-modal-dialog/offer-preview-modal-dialog.component.ts